import { Button, Popconfirm } from "antd";
import moment from "moment";
export const getColumns = (openModal, handleDelete) => [
  { title: "Service Name", dataIndex: "serviceName", key: "serviceName" },
  {
    title: "Kind of Service",
    dataIndex: "kindOfService",
    key: "kindOfService",
  },
  { title: "Charge Type", dataIndex: "chargeType", key: "chargeType" },
  { title: "Service Price", dataIndex: "servicePrice", key: "servicePrice" },
  {
    title: "Service Description",
    dataIndex: "serviceDescription",
    key: "serviceDescription",
  },
  {
    title: "Date Applied",
    dataIndex: "dateApplied",
    key: "dateApplied",
    render: (_, record) => (
      <span>
        {moment(record.dateApplied.startDate).format("DD-MM-YYYY")} -{" "}
        {moment(record.dateApplied.endDate).format("DD-MM-YYYY")}
      </span>
    ),
  },
  {
    title: "Actions",
    key: "actions",
    render: (_, record) => (
      <>
        <Button
          type="primary"
          style={{ marginRight: 8 }}
          onClick={() => openModal(record)}
        >
          Edit
        </Button>
        <Popconfirm
          title="Are you sure to delete this add on service?"
          onConfirm={() => handleDelete(record._id)}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <Button type="link" danger>
            Delete
          </Button>
        </Popconfirm>
      </>
    ),
  },
];
